import { queryOptions } from '@tanstack/react-query';
import type { ConnectorStatusDto, TenantDto } from '@atnt/shared';
import { api } from '@/shared/api/client';

export const tenantBase = (tenantId: string) => `/tenants/${encodeURIComponent(tenantId)}`;

export const connectorKeys = {
  /** real: live source status of the API (`GET /tenants/:t/connector-status`) */
  status: (tenantId: string) => ['tenant', tenantId, 'connector-status'] as const,
  /** real: tenant details (`externalSiteId` = unified-server site code) */
  tenant: (tenantId: string) => ['tenant', tenantId, 'details'] as const,
  all: (tenantId: string) => ['tenant', tenantId, 'connectors'] as const,
  list: (tenantId: string) => ['tenant', tenantId, 'connectors', 'list'] as const,
  detail: (tenantId: string, id: string) => ['tenant', tenantId, 'connectors', 'detail', id] as const,
  sensors: (tenantId: string, id: string) => ['tenant', tenantId, 'connectors', 'sensors', id] as const,
  log: (tenantId: string, id: string) => ['tenant', tenantId, 'connectors', 'log', id] as const,
};

export const connectorStatusQuery = (tenantId: string) =>
  queryOptions({
    queryKey: connectorKeys.status(tenantId),
    queryFn: () => api.get<ConnectorStatusDto>(`${tenantBase(tenantId)}/connector-status`),
    refetchInterval: 15_000,
  });

export const tenantDetailsQuery = (tenantId: string) =>
  queryOptions({ queryKey: connectorKeys.tenant(tenantId), queryFn: () => api.get<TenantDto>(tenantBase(tenantId)) });
